module.exports = __webpack_public_path__ + "img/chai_event.620c5afc.png";